import React, { useState } from "react";
import {
  Button,
  ImgContainer,
  InfoContainer,
  ModalContainer,
  ModalWrapper,
  TransactionMassage,
} from "./index.styled";
import successImg from "assets/images/Done.png";
import failImg from "assets/images/fail.png";

const BankResult = ({ isSuccessful, data }) => {
  const [showModal, setShowModal] = useState(true);
  const handleShowModal = () => {
    setShowModal(false);
  };

  return (
    <>
      {showModal ? (
        <ModalContainer>
          <ModalWrapper>
            <ImgContainer>
              {isSuccessful ? (
                <img src={successImg} alt="success" />
              ) : (
                <img src={failImg} alt="fail" />
              )}
            </ImgContainer>
            <TransactionMassage>
              {isSuccessful ? (
                <h2>تراکنش با موفقیت انجام شد.</h2>
              ) : (
                <h2>عملیات پرداخت با موفقیت انجام نشد.</h2>
              )}
            </TransactionMassage>
            <InfoContainer>
              <div>
                <div>تاریخ:</div>
                <div className="date">
                  <p>{data.localDate}</p>
                  <p>{data.localTime}</p>
                </div>
              </div>
              <div>
                <div>کد رهگیری:</div>
                <div>{data.RefId}</div>
              </div>
            </InfoContainer>

            <Button onClick={handleShowModal}>تایید</Button>
          </ModalWrapper>
        </ModalContainer>
      ) : (
        ""
      )}
    </>
  );
};

export default BankResult;
